<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <h3>推广商品</h3>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="三方平台">
          <el-select v-model="listQuery.platform" filterable placeholder="请选择三方平台">
            <el-option label="全部" value='' />
            <el-option v-for="item in platforms" :key="item.code" :label="item.name" :value='item.code' />
          </el-select>
        </el-form-item>
        <el-form-item label="子渠道ID">
          <el-input v-model="listQuery.promotionLinkCode" placeholder="输入推广ID查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="所属达人">
          <el-input v-model="listQuery.authorName" placeholder="输入所属达人查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="达人ID">
          <el-input v-model="listQuery.authorId" placeholder="输入达人ID查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="listQuery.linkStatus" filterable placeholder="请选择状态">
            <el-option label="全部" value='' />
            <el-option label="开启中" value='1' />
            <el-option label="已停用" value='0' />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <div class="btns-style">
          <el-button class="down-code btnCreate" type="primary" @click="create('create')">创建达人带货</el-button>
          <p>创建后可以拿到自己的专属带货链接</p>
        </div>
      </el-form>
      <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :header-cell-style="tableHeader" @selection-change="handleSelectionChange">
        <el-table-column label="子渠道ID" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.promotionLinkCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="三方平台" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ getPlatformValue(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="核桃商品名称" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ getValue('agentCourse.name', row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="核桃商品ID" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ getValue('agentCourse.id', row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺商品ID" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ getValue('agentCourse.productId', row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺商品名称" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ getValue('agentCourse.productName', row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="带货商品链接（达人用）" align="center" width="200">
          <template slot-scope="{ row }">
            <span class="icon" v-if="row.linkUpdateBoolean">新</span>
            <span>{{ row.link || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属达人（昵称）" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.authorName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="达人ID" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.authorId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备用商品ID" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ getValue('agentCourse.batProductId', row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备用商品链接" align="center" width="200">
          <template slot-scope="{ row }">
            <span>{{ getValue('agentCourse.batProductLink', row) || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.ctime ? timestampToDate(row.utime) : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{ row }">
            <div v-if="row.linkStatus === 1">
              <el-button type="text" @click="deactivatePromotedLinks(row)" style="color:#FF9900;">停用</el-button>
              <el-button v-if="getValue('agentCourse.courseStatus', row) === 0" type="text" style="color:#FF9900;" v-copy="row.link" v-copy:callback="clipboardSuccessHandler" >复制链接</el-button>
              <el-button type="text" @click="watchDetail(row)" style="color:#FF9900;">查看详情</el-button>
            </div>
            <div v-else-if="row.linkStatus === 0">
              <el-button type="text" @click="enablePromotedLinks(row)" style="color:#FF9900;">启用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNumber" :limit.sync="listQuery.pageSize" @pagination="getList" />
      <!-- 创建推广链接弹窗 -->
      <el-dialog title="创建达人带货" :visible.sync="dialogVisible" width="630px" :before-close="cancelDialog">
        <el-form :model="editQuery" :rules="LevelSRules" label-width="130px" ref="linkRef">
          <el-form-item prop="platform" label="选择平台">
            <el-select v-model="editQuery.platform" filterable placeholder="请选择平台" class="selectWidth"  @change="changePlatform">
              <el-option
                v-for="item in platforms"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="courseId" label="选择带货商品">
            <el-select v-model="editQuery.courseId" filterable placeholder="请选择带货商品" class="selectWidth" @change="getCourseInfo">
              <el-option v-for="item in courseList" :key="item.teamCourseId" :label="item.teamCourseName + '#' + item.id" :value="item.teamCourseId"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="promotionPositionCode" label="选择达人">
            <el-select v-model="editQuery.promotionPositionCode" filterable placeholder="请选择达人" class="selectWidth">
              <el-option v-for="item in authorList" :key="item.id" :label="item.authorName + '#' + item.authorId" :value="item.promotionPositionCode"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品ID">
            <span>{{ (getValue('courseInfo.productId') + ' -- ' + getValue('courseInfo.teamCourseName')) || "--" }}</span>
          </el-form-item>
          <el-form-item label="商品链接">
            <span>{{ getValue('courseInfo.link') || "--" }}</span>
          </el-form-item>
          <el-form-item label="备用商品ID">
            <span>{{ (getValue('courseInfo.batProductId') + ' -- ' + getValue('courseInfo.batName')) || "--" }}</span>
          </el-form-item>
          <el-form-item label="备用商品链接">
            <span>{{ getValue('courseInfo.batProductLink') || "--" }}</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" :loading="createLoading" @click="confirmDialog()">创 建</el-button>
        </span>
      </el-dialog>
      <!-- 推广链接详情弹窗 -->
      <el-dialog title="推广链接商品" :visible.sync="detailVisible" width="600px" :before-close="cancelDetail">
        <el-form label-width="110px">
          <el-form-item prop="name" label="带货商品">
            <span>{{ getValue('currentItem.agentCourse.teamCourseName') || "--" }}</span>
          </el-form-item>
          <el-form-item label="达人昵称">
            <span>{{ getValue('currentItem.authorName') || "--" }}</span>
          </el-form-item>
          <el-form-item label="达人ID">
            <span>{{ getValue('currentItem.authorId') || "--" }}</span>
          </el-form-item>
          <el-form-item label="商品ID">
            <span>{{ getValue('currentItem.agentCourse.productId') || "--" }}</span>
          </el-form-item>
          <el-form-item label="商品链接">
            <a :href="handleUrl(getValue('currentItem.link'))" target="_blank" rel="noopener noreferrer" class="blue">
              {{ getValue('currentItem.link') || "--" }}
            </a>
          </el-form-item>
          <el-form-item label="备用商品ID">
            <span>{{ getValue('currentItem.agentCourse.batProductId') || "--" }}</span>
          </el-form-item>
          <el-form-item label="备用商品链接">
            <a :href="handleUrl(getValue('currentItem.agentCourse.batProductLink'))" target="_blank" rel="noopener noreferrer" class="blue">
              {{ getValue('currentItem.agentCourse.batProductLink') || "--" }}
            </a>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancelDetail">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 编辑推广链接弹窗 -->
      <el-dialog title="编辑推广链接" :visible.sync="editVisible" width="600px" :before-close="cancelEdit">
        <el-form label-width="130px" :model="editItem" :rules="EditRules" ref="editRef">
          <el-form-item prop="promotionLinkName" label="链接名称">
            <el-input type="text" v-model="editItem.promotionLinkName" placeholder="请输入链接名称" class="selectWidth numrule" maxlength="50" />
          </el-form-item>
          <el-form-item label="推广课程">
            <span>{{ getValue('editItem.agentCourse.name') || "--" }}</span>
          </el-form-item>
          <el-form-item label="课程描述">
            <span>{{ getValue('editItem.agentCourse.courseDesc') || "--" }}</span>
          </el-form-item>
          <el-form-item label="落地页链接">
            <a :href="handleUrl(editItem.link)" target="_blank" rel="noopener noreferrer" class="blue">
              {{ editItem.link || "--" }}
            </a>
          </el-form-item>
          <el-form-item label="是否生成小程序码">
            <span>{{ editItem && editItem.info && editItem.info.showMiniprogram === "true" ? "是" : "否" }}</span>
          </el-form-item>
          <el-form-item label="推广渠道">
            {{ editItem.channelName || "--" }}
          </el-form-item>
          <el-form-item label="推广渠道">
            {{ editItem.positionName || "--" }}
          </el-form-item>
          <el-form-item label="链接归属人">
            {{ editItem.linkBelongerCode && Number(editItem.linkBelongerCode) !== 0 ? editItem.agentName : "无归属人" }}
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelEdit">取 消</el-button>
          <el-button type="primary" @click="editLink()">保 存</el-button>
        </span>
      </el-dialog>
      <!-- 推广链接批量下载 -->
      <el-dialog title="推广链接批量下载" :visible.sync="visibleDialog" :before-close="handleClose" :close-on-click-modal="false" top="3vh" width="700px">
        <div>
          <downLoad ref="childDown" @handleResult="handleClose"></downLoad>
        </div>
      </el-dialog>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from "js-cookie";
import { encode } from "js-base64";
import { mapActions, mapGetters } from "vuex";

import PowerWrapper from "@/components/PowerWrapper";
import Pagination from "@/components/Pagination/index";

import { getLinkList, getCourseList, editProduct, addProduct, deactivatePromotedLinks, enablePromotedLinks } from "@/services/link";
import { getThirdPartyPromotionList } from "@/services/promotion";
import { getThirdPlatforms } from "@/services/order";
import { delUndefined, timestampToDateTotal } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole } from "@/utils/auth";

import downLoad from "./components/downLoad";
export default {
  name: "links",
  components: {
    Pagination,
    PowerWrapper,
    downLoad
  },
  data() {
    return {
      CurrRole: "links",
      list: [],
      authorList: [],
      showDeleted: false,
      createLoading: false,
      listQuery: {
        pageSize: 10,
        pageNumber: 1,
        linkBelongerCode: null,
        promotionLinkCode: null,
        promotionChannelCode: null,
        linkStatus: null,
      },
      total: 1,
      listLoading: false,
      dialogVisible: false,
      detailVisible: false,
      editQuery: {
        platform: null,
        courseId: null,
        promotionPositionCode: null
      },
      editItem: {},
      editVisible: false,
      allMembers: [],
      LevelSRules: {
        platform: [{ required: true, message: "请选择平台", trigger: ["blur", "change"] }],
        courseId: [{ required: true, message: "请选择带货商品", trigger: ["blur", "change"] }],
        promotionPositionCode: [{ required: true, message: "请选择达人", trigger: ["blur", "change"] }],
      },
      EditRules: {
        promotionLinkName: { required: true, message: "请输入链接名称" }
      },
      courseList: [],
      courseInfo: {},
      teamListNew: [],
      multipleSelection: [],
      channelCode: null,
      currentItem: {},
      downloadParam: {},
      visibleDialog: false,
      platforms: [],
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { "background-color": "#f5f5f5" };
      };
    },
    ...mapGetters(["linkCreate"])
  },
  created() {
    this.getList();
    this.getSignature();
    this.getThirdPlatforms();
  },
  methods: {
    ...mapActions(["getOssSignature"]),
    getValue(s, self = this) {
      const split = String.prototype.split;
      const keys = split.call(s, '.') || [];
      if (!keys.join('')) return null;
      return keys.reduce((acc = {}, cur) => acc[cur], self) || '';
    },
    getPlatformValue(row = {}) {
      const { platform } = row.agentCourse || {};
      if (!platform) return '--';
      const _platform = this.platforms.find(item => item.code === platform);
      return _platform?.name;
    },
    async getThirdPlatforms() {
      try {
        const res = await getThirdPlatforms();
        const { errCode, errMsg, data } = res.data;
        if (errCode === 0) {
          this.platforms = data;
        } else {
          this.$message({ type: 'error', message: errMsg })
        }
      } catch (error) {
        this.$message({ type: 'error', message: '三方平台获取失败！请稍后重试' })
      }
    },
    async getSignature() {
      const data = await this.getOssSignature();
      this.ossParams = {
        ...this.ossParams,
        OSSAccessKeyId: data.id,
        signature: data.signature,
        policy: data.policy
      };
    },
    toPosition() {
      this.$router.push({ path: "/position/list" });
    },
    getCheckValue(value) {
      this.showDeleted = value;
      this.getList("search");
    },
    // 手机号隐藏中间4位
    handlePhone(tel) {
      const reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    handleUrl(url) {
      const newUrl = url && url.indexOf("http") === -1 && url.indexOf("https") === -1 ? `https://${url}` : url;
      return newUrl;
    },
    timestampToDate(time) {
      return timestampToDateTotal(time);
    },
    getCourseInfo(e) {
      if (e && this.courseList.length > 0) {
        this.courseInfo = this.courseList.find(item => item.teamCourseId && Number(item.teamCourseId) === Number(e));
      }
    },
    changePlatform(platform) {
      this.getPromotionList(platform);
      this.getCourseList(platform);
    },
    getPromotionList(platform) {
      const params = {
        platform,
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0
      }
      getThirdPartyPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          const orderList = res.data.data;
          this.authorList = orderList;
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.list = [];
        }
      });
    },
    getCourseList(platform) {
      getCourseList(platform).then(res => {
        const { data, errCode } = res?.data || {};
        if (errCode === 0) {
          const list = data.list || [];
          this.editQuery.courseId = list[0]?.teamCourseId;
          this.courseInfo = list[0];
          this.courseList = list;
        } else if (errCode === 1016) {
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.courseList = [];
        }
      });
    },
    getList(btnName) {
      this.listLoading = true;
      const params = {
        ...this.listQuery,
        pageNumber: btnName === "search" ? 1 : this.listQuery.pageNumber,
        teamCode: getTeamCode(),
        agentCode: getAgentCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        showDeleted: this.showDeleted
      };
      getLinkList(delUndefined(params)).then(res => {
        const { data, errCode } = res?.data || {};
        const { list, total } = data || {};
        if (errCode === 0 && list && list.length > 0) {
          this.listLoading = false;
          this.list = list;
          this.total = total;
          if (btnName === "search") {
            this.listQuery.pageNumber = 1;
          }
        } else if (errCode === 1016) {
          this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
    },
    handleSearch() {
      this.getList("search");
    },
    create(type) {
      if (this.$refs.linkRef) this.$refs.linkRef.clearValidate();
      // 弹窗类型
      this.dialogVisible = true;
      this.editQuery.promotionPositionCode = null;
    },
    edit(item) {
      this.editVisible = true;
      this.editItem = Object.assign({}, item);
    },
    async editLink() {
      await this.$refs.editRef.validate();
      const { id, promotionLinkName } = this.editItem;
      const res = await editProduct({
        type: "PUT",
        params: {
          id,
          promotionLinkName,
          teamCode: getTeamCode()
        }
      });
      const { errCode, errMsg } = res.data;
      if (errCode === 0) {
        this.$message({ type: "success", message: "编辑成功" });
        this.cancelEdit();
        this.getList();
      } else if (errCode === 1016) {
        this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
        Cookie.remove("staffToken");
        setTimeout(() => {
          this.$router.push({ path: "/login" });
        }, 3000);
      } else {
        this.$message({ type: "error", message: errMsg });
      }
    },
    watchDetail(item) {
      this.detailVisible = true;
      this.currentItem = item;
      console.log('item ', item)
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.editQuery.promotionLinkName = "";
      this.editQuery.platform = null;
      this.editQuery.courseId = null;
      this.editQuery.promotionPositionCode = null;
      this.courseInfo = {};
    },
    cancelDetail() {
      this.detailVisible = false;
    },
    cancelEdit() {
      this.editVisible = false;
      this.$refs.editRef.clearValidate();
    },
    confirmDialog() {
      this.$refs.linkRef.validate(async valid => {
        if (!valid) return false;
        const { editQuery, courseInfo } = this;
        const { channelGroupId, channelGroupName, link, id } = courseInfo
        const params = {
          ...editQuery,
          courseId: id,
          channelGroupId,
          channelGroupName,
          link,
          linkBelongerCode: 0,
          teamCode: getTeamCode(),
          createAgentCode: getAgentCode(),
        }
        this.createLoading = true;
        addProduct({
          type: "POST",
          params: {
            ...delUndefined(params)
          }
        }).then(res => {
          this.createLoading = false;
          if (res.data && res.data.errCode === 0) {
            this.$message({ type: "success", message: "达人带货创建成功" });
            this.cancelDialog();
            this.getList();
          } else if (res.data && res.data.errCode === 1016) {
            this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
            Cookie.remove("staffToken");
            setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 3000);
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        }).catch(err => {
          this.createLoading = false;
          this.$message({ type: "error", message: err });
        });
      });
    },
    // 创建或编辑接口
    createOrEditApi(id, params) {
      if (this.isEdit) {
        // 编辑
        editProduct({
          type: "PUT",
          params: {
            id: id ? Number(id) : null,
            ...delUndefined(params)
          }
        }).then(res => {
          if (res.data && res.data.errCode === 0) {
            this.$message({ type: "success", message: "编辑推广链接成功" });
            this.getList();
            this.dialogVisible = false;
          } else if (res.data && res.data.errCode === 1016) {
            this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
            Cookie.remove("staffToken");
            setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 3000);
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        });
      } else {
        addProduct({
          type: "POST",
          params: {
            ...delUndefined(params)
          }
        }).then(res => {
          if (res.data && res.data.errCode === 0) {
            this.$message({ type: "success", message: "创建推广链接成功" });
            this.editQuery.promotionLinkName = "";
            this.getList();
            this.dialogVisible = false;
          } else if (res.data && res.data.errCode === 1016) {
            this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
            Cookie.remove("staffToken");
            setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 3000);
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        });
      }
    },
    alertBox(msg) {
      this.$confirm(msg, "", {
        distinguishCancelAndClose: true,
        showConfirmButton: false,
        cancelButtonText: "关闭",
        cancelButtonClass: "btnClose"
      })
        .then(() => {
          console.log();
        })
        .catch(() => {
          console.log();
        });
    },
    clipboardSuccessHandler() {
      this.$notify({
        title: "提示：",
        message: "复制成功",
        type: "success"
      });
    },
    // 批量下载弹窗
    download() {
      this.visibleDialog = true;
      if (this.$refs.childDown) {
        this.$refs.childDown.getListNew();
      }
    },
    handleClose() {
      this.visibleDialog = false;
    },
    saveImg() {
      const cvs = document.getElementById("qrcode").getElementsByTagName("canvas");
      const a = document.createElement("a");
      a.href = cvs[0].toDataURL("image/png").replace("image/png", "image/octet-stream");
      a.download = "qrcode.png";
      a.click();
    },
    getPosterImg({ poster, shortLinkQrCode }) {
      const imgPath = shortLinkQrCode.replace(/^https?\:\/\/img\.hetao101\.com\//, "");
      console.log("imgPath ", imgPath);
      const qrcode = `${imgPath}?x-oss-process=image/resize,w_${186},h_${186}`;
      const posterimg = `image_${encode(qrcode)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/\=/g, "")},g_se,x_55,y_34`;
      return `${poster}?x-oss-process=image/resize,w_750/watermark,${posterimg}`;
    },
    getMpQrcodeImg(key) {
      return `https://img.hetao101.com/${key}`;
    },
    saveMiniprogramImg(url) {
      const a = document.createElement("a");
      if (url && url.indexOf("?") > -1) {
        a.href = `${url}&response-content-type=application/octet-stream`;
      } else {
        a.href = `${url}?response-content-type=application/octet-stream`;
      }
      a.download = "mp-qrcode.png";
      a.target = "_blank";
      a.click();
    },
    getMpQrcodePosterImg(url, shortLinkQrCode) {
      const imgPath = shortLinkQrCode.replace(/^https?\:\/\/img\.hetao101\.com\//, "");
      console.log("imgPath ", imgPath);
      const qrcode = `${imgPath}?x-oss-process=image/resize,w_${186},h_${186}`;
      const posterimg = `image_${encode(qrcode)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/\=/g, "")},g_se,x_55,y_34`;
      return `${url}?x-oss-process=image/resize,w_750/watermark,${posterimg}`;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deactivatePromotedLinks(row) {
      this.$confirm("停用后链接将失效", "停用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const { id } = row;
          const res = await deactivatePromotedLinks({ id });
          const { data } = res;
          if (data.errCode === 0) {
            this.listQuery.pageSize = 10;
            this.listQuery.pageNumber = 1;
            this.getList();
            this.$message({
              type: "success",
              message: "停用成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.errMsg
            });
          }
        } catch (error) {
          this.$message({
            type: "error",
            message: error
          });
        }
      });
    },
    async enablePromotedLinks(row) {
      const userRole = Number(getTeamRole());
      if (userRole !== 1 && userRole !== 2) {
        this.$confirm("请联系渠道创建者恢复！", "启用", {
          showCancelButton: false,
          showConfirmButton: false,
          type: "warning"
        });
        return;
      }
      this.$confirm("是否要启用?", "启用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const { id } = row;
          const res = await enablePromotedLinks({ id });
          const { data } = res;
          if (data.errCode === 0) {
            this.listQuery.pageSize = 10;
            this.listQuery.pageNumber = 1;
            this.getList();
            this.$message({
              type: "success",
              message: "启用成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.errMsg
            });
          }
        } catch (error) {
          this.$message({
            type: "error",
            message: error
          });
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/common.less";
.exportExcel {
  float: right;
  margin-top: 3px;
}
span.icon{
  border: 1px solid #fe9400;
  border-radius: .5em;
  font-size: 12px;
  margin-right: 6px;
  padding: 0 5px;
  color: #fe9400;
}
.distributorList {
  .showRemoved {
    float: right;
    margin-top: -35px;
  }
  .btnStyle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    color: #ff9900;
  }
  .filter-item-new,
  .qrcode-style {
    display: inline-block;
  }
  .qrcode-style {
    vertical-align: top;
    margin-top: 12px;
  }
  .qrcode_box {
    li {
      width: 200px;
      float: left;
      text-align: center;
    }
  }
  .poster_img {
    height: 150px;
    padding-top: 12px;
    display: block;
    margin: 0 auto 18px;
  }
  .save-img {
    clear: both;
    margin: 12px auto;
    padding: 0 20px;
    display: inline-block;
    background: #fe9400;
    color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    line-height: 32px;
  }
  .btns-style {
    float: right;
    .btn {
      margin-top: 3px;
      margin-right: -5px;
    }
    p {
      display: block;
      clear: both;
      color: #409eff;
    }
    .down-code {
      margin-top: 3px;
      margin-left: 10px;
      float: right;
    }
  }
  .selectWidth {
    width: 300px;
  }
  .inputWidth {
    width: 380px;
  }
  .blue {
    display: inline-block;
    color: #409eff;
    line-height: 22px;
    margin-top: 8px;
  }
  .toPosition {
    cursor: pointer;
    color: #ff9900;
  }
  .red {
    color: red;
    margin-left: 10px;
  }
  .attention {
    margin-left: 35px;
    i {
      font-size: 18px;
      vertical-align: top;
      margin: 6px;
    }
  }
}
.mp-container {
  // padding: 10px 0;
  background: rgba(242, 242, 242, 1);
  font-size: 12px;
}
</style>
<style>
.btnFalses,
.btnClose {
  color: #fff !important;
  background-color: #fe9400 !important;
  border-color: #fe9400 !important;
}
</style>
